/** @jsx React.DOM */
var React = require('react/addons')
var remotes = require('../../../helpers/remotes')
var num = require('num')
var numbers = require('../../../helpers/numbers')
var constants = require('../../../helpers/constants')
var formatters = require('../../../helpers/formatters')
var transactionsHelper = require('../../../helpers/transactions')
var TransactionDescription = require('../../../partials/rmc/transaction-description')
var AccountInfo = require('./info')
var AccountTransactions = require('./transactions')
var config = require('json!../../../config.json')

var Account = React.createClass({displayName: 'Account',
  componentWillMount: function() {
    document.title = this.props.params.account + config.documentTitleSuffix
  },

  render: function() {
    var account = this.props.params.account

    return React.DOM.div({className: "container"}, 
      React.DOM.h3({title: account}, account.substr(0, 7)), 
      AccountInfo({account: account}), 
      AccountTransactions({account: account})
    )
  }
})

module.exports = Account



//////////////////
// WEBPACK FOOTER
// ./src/routes/rmc/account/index.jsx
// module id = 466
// module chunks = 0